export default "__VITE_ASSET__DncZDoXD__"